export default __webpack_public_path__ + "static/media/en_vrai_c@etait_bien_1_lowdef.044a8ce0.png";